/** @format */

import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
//import Clients from "./views/Clients.vue";

import CustomPortfolios from "./views/CustomPortfolios.vue";
import Messages from "./views/Messages.vue";

import ClientView2 from "./views/ClientView2.vue";

import ClientListV2 from "./views/ClientListV2.vue";
import UserListV2 from "./views/UserListV2.vue";
import ProposalsV2 from "./views/ProposalsV2.vue";
import PlanViewV2 from "./views/PlanViewV2.vue";

import CustomPortfolioEdit from "./views/CustomPortfolioEdit.vue";

import V2 from "./views/V2.vue";
import V3GoalProjection from "./views/V3GoalProjection.vue";

import V2GoalProjection from "./views/V21GoalProjection.vue";
import PartnerSettings from "./views/PartnerSettings.vue";

import Login from "./views/Login.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: ClientListV2,
      meta: {
        title: "Home",
      },
    },
    {
      path: "/users",
      name: "users",
      component: UserListV2,
      meta: {
        title: "Users",
      },
    },
    {
      path: "/setup",
      name: "setup",
      component: Login,
      meta: {
        title: "Create",
      },
    },
    {
      path: "/customportfolios",
      name: "customportfolios",
      component: CustomPortfolios,
      meta: {
        title: "Portfolio Mapping",
      },
    },
    {
      path: "/mapping/:currency/:id",
      name: "mapping",
      component: CustomPortfolioEdit,
      meta: {
        title: "Custom Portfolio Mapping",
      },
    },
    {
      path: "/messages",
      name: "Messages",
      component: Messages,
    },
    {
      path: "/settings",
      name: "settings",
      component: PartnerSettings,
    },

    {
      path: "/v2/clients",
      name: "v2clients",
      component: ClientListV2,
    },
    {
      path: "/v2/plans",
      name: "v2plans",
      component: ProposalsV2,
    },
    {
      path: "/v2/plans/:id",
      name: "v2planview",
      component: PlanViewV2,
    },
    {
      path: "/v2/client/:id",
      name: "editClientv2",
      component: ClientView2,
    },

    {
      path: "/v2",
      name: "v2",
      component: V2,
    },
    {
      path: "/v2/client/:clientid/goals/:id",
      name: "v2GoalProjection",
      component: V2GoalProjection,
    },
    {
      path: "/v3/client/:clientid/goals/:id",
      name: "v3GoalProjection",
      component: V3GoalProjection,
    },
  ],
});
